import formatMoney from "lib/formatMoney";
import dayjs from "dayjs";

const CalculatorQuestions = [
  {
    q_id: "0",
    q_title: "Salary",
    q_description: () => {
      return "Enter your monthly salary or wages from employment";
    },
    node_type: "node",
    a_type: "currency",
    a_opts: (answers) => {
      return [];
    },
    q_next_step_func: (answer, answers, questions) => {
      return answer.q_id + "0";
    },
    q_child_nodes: [0],
    q_validation_func: (answerVal) => {
      if (answerVal < 0) return false;
      return true;
    },
    q_invalid_answer_help_text: "Please enter a value above 0",
    a_error: false,
  },
  {
    q_id: "00",
    q_title: "Investment income",
    q_description: () => {
      return "Enter your monthly income from investments, dividends, or interest";
    },
    node_type: "node",
    a_type: "currency",
    a_opts: (answers) => {
      return [];
    },
    q_next_step_func: (answer, answers, questions) => {
      return answer.q_id + "0";
    },
    q_child_nodes: [0],
    q_validation_func: (answerVal) => {
      if (answerVal < 0) return false;
      return true;
    },
    q_invalid_answer_help_text: "Please enter a value above 0",
    a_error: false,
  },
  {
    q_id: "000",
    q_title: "Other income",
    q_description: () => {
      return "Enter any other monthly income (e.g., rental income, alimony, etc.)";
    },
    node_type: "node",
    a_type: "currency",
    a_opts: (answers) => {
      return [];
    },
    q_next_step_func: (answer, answers, questions) => {
      return answer.q_id + "0";
    },
    q_child_nodes: [0],
    q_validation_func: (answerVal) => {
      if (answerVal < 0) return false;
      return true;
    },
    q_invalid_answer_help_text: "Please enter a value above 0",
    a_error: false,
  },
  {
    q_id: "0000",
    q_title: "Mortgage",
    q_description: () => {
      return "Enter your monthly mortgage payment";
    },
    node_type: "node",
    a_type: "currency",
    a_opts: (answers) => {
      return [];
    },
    q_next_step_func: (answer, answers, questions) => {
      return answer.q_id + "0";
    },
    q_child_nodes: [0],
    q_validation_func: (answerVal) => {
      if (answerVal < 0) return false;
      return true;
    },
    q_invalid_answer_help_text: "Please enter a value above 0",
    a_error: false,
  },
  {
    q_id: "00000",
    q_title: "Rent",
    q_description: () => {
      return "Enter your monthly rent payment";
    },
    node_type: "node",
    a_type: "currency",
    a_opts: (answers) => {
      return [];
    },
    q_next_step_func: (answer, answers, questions) => {
      return answer.q_id + "0";
    },
    q_child_nodes: [0],
    q_validation_func: (answerVal) => {
      if (answerVal < 0) return false;
      return true;
    },
    q_invalid_answer_help_text: "Please enter a value above 0",
    a_error: false,
  },
  {
    q_id: "000000",
    q_title: "Property tax",
    q_description: () => {
      return "Enter your monthly property tax payment";
    },
    node_type: "node",
    a_type: "currency",
    a_opts: (answers) => {
      return [];
    },
    q_next_step_func: (answer, answers, questions) => {
      return answer.q_id + "0";
    },
    q_child_nodes: [0],
    q_validation_func: (answerVal) => {
      if (answerVal < 0) return false;
      return true;
    },
    q_invalid_answer_help_text: "Please enter a value above 0",
    a_error: false,
  },
  {
    q_id: "0000000",
    q_title: "Insurance",
    q_description: () => {
      return "Enter your monthly insurance payment";
    },
    node_type: "node",
    a_type: "currency",
    a_opts: (answers) => {
      return [];
    },
    q_next_step_func: (answer, answers, questions) => {
      return answer.q_id + "0";
    },
    q_child_nodes: [0],
    q_validation_func: (answerVal) => {
      if (answerVal < 0) return false;
      return true;
    },
    q_invalid_answer_help_text: "Please enter a value above 0",
    a_error: false,
  },
  {
    q_id: "00000000",
    q_title: "HOA",
    q_description: () => {
      return "Enter your monthly HOA payment";
    },
    node_type: "node",
    a_type: "currency",
    a_opts: (answers) => {
      return [];
    },
    q_next_step_func: (answer, answers, questions) => {
      return answer.q_id + "0";
    },
    q_child_nodes: [0],
    q_validation_func: (answerVal) => {
      if (answerVal < 0) return false;
      return true;
    },
    q_invalid_answer_help_text: "Please enter a value above 0",
    a_error: false,
  },
  {
    q_id: "000000000",
    q_title: "Credit card payment",
    q_description: () => {
      return "Enter your total monthly credit card payments";
    },
    node_type: "node",
    a_type: "currency",
    a_opts: (answers) => {
      return [];
    },
    q_next_step_func: (answer, answers, questions) => {
      return answer.q_id + "0";
    },
    q_child_nodes: [0],
    q_validation_func: (answerVal) => {
      if (answerVal < 0) return false;
      return true;
    },
    q_invalid_answer_help_text: "Please enter a value above 0",
    a_error: false,
  },
  {
    q_id: "0000000000",
    q_title: "Student loan payment",
    q_description: () => {
      return "Enter your monthly student loan payment";
    },
    node_type: "node",
    a_type: "currency",
    a_opts: (answers) => {
      return [];
    },
    q_next_step_func: (answer, answers, questions) => {
      return answer.q_id + "0";
    },
    q_child_nodes: [0],
    q_validation_func: (answerVal) => {
      if (answerVal < 0) return false;
      return true;
    },
    q_invalid_answer_help_text: "Please enter a value above 0",
    a_error: false,
  },
  {
    q_id: "00000000000",
    q_title: "Auto loan payment",
    q_description: () => {
      return "Enter your monthly auto loan payment";
    },
    node_type: "node",
    a_type: "currency",
    a_opts: (answers) => {
      return [];
    },
    q_next_step_func: (answer, answers, questions) => {
      return answer.q_id + "0";
    },
    q_child_nodes: [0],
    q_validation_func: (answerVal) => {
      if (answerVal < 0) return false;
      return true;
    },
    q_invalid_answer_help_text: "Please enter a value above 0",
    a_error: false,
  },
  {
    q_id: "000000000000",
    q_title: "Other liability payments",
    q_description: () => {
      return "Enter any other monthly debt payments";
    },
    node_type: "node",
    a_type: "currency",
    a_opts: (answers) => {
      return [];
    },
    q_next_step_func: (answer, answers, questions) => {
      return answer.q_id + "0";
    },
    q_child_nodes: [0],
    q_validation_func: (answerVal) => {
      if (answerVal < 0) return false;
      return true;
    },
    q_invalid_answer_help_text: "Please enter a value above 0",
    a_error: false,
  },
  {
    q_id: "0000000000000",
    q_title: "Calculation name",
    q_description: () => {
      return "What would you like to name this calculation?";
    },
    node_type: "node",
    a_type: "text",
    a_input_type: "text",
    a_opts: (answers) => {
      return [];
    },
    q_next_step_func: (answer, answers, questions) => {
      return answer.q_id + "0";
    },
    q_child_nodes: [0],
    q_validation_func: (answerVal) => {
      if (!answerVal || answerVal.length === 0) return false;
      return true;
    },
    q_invalid_answer_help_text: "Please enter a name for this calculation",
    a_error: false,
  },
  {
    q_id: "00000000000000",
    q_title: "Address (optional)",
    q_description: () => {
      return "Enter property address to help organize your calculations";
    },
    node_type: "node",
    a_type: "address",
    a_opts: (answers) => {
      return [];
    },
    q_next_step_func: (answer, answers, questions) => {
      return answer.q_id + "0";
    },
    q_child_nodes: [0],
    q_validation_func: (answerVal) => {
      return true; // Optional field
    },
    q_invalid_answer_help_text: "",
    a_error: false,
  },
];

export default CalculatorQuestions;
